import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

// V2.14 — Beta banner. Visible when REACT_APP_SHOW_BETA_BANNER is "true"
// (default) OR when running in production build. Dismissible per browser
// (localStorage). Set REACT_APP_SHOW_BETA_BANNER="false" in the deployment
// env to hide globally when the app graduates to GA.
const DISMISS_KEY = "beta_dismissed";

function shouldShow() {
  const flag = process.env.REACT_APP_SHOW_BETA_BANNER;
  if (flag === "false") return false;
  if (flag === "true") return true;
  return process.env.NODE_ENV === "production";
}

export default function BetaBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!shouldShow()) return;
    try {
      if (localStorage.getItem(DISMISS_KEY) === "1") return;
    } catch {}
    setVisible(true);
  }, []);

  if (!visible) return null;
  return (
    <div
      data-testid="beta-banner"
      className="flex items-center justify-center gap-3 border-b border-amber-300 bg-amber-100/90 px-4 py-1.5 text-xs font-medium text-amber-900"
      role="status"
    >
      <span>{t("common.beta_banner")}</span>
      <button
        type="button"
        data-testid="beta-banner-dismiss"
        onClick={() => {
          try { localStorage.setItem(DISMISS_KEY, "1"); } catch {}
          setVisible(false);
        }}
        aria-label="Dismiss"
        className="rounded-full p-0.5 text-amber-900/70 hover:bg-amber-200 hover:text-amber-900"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
